// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xx51N","content":"styles_content__Qz4A2","tableWrap":"styles_tableWrap__h77N5"};